<template>
  <div class="input-group">
    <div class="input-group-prepend" hidden="">
      <select
        class="input-group-text form-control bg-primary"
        v-model="selectedSearchFilterId"
        @change="changeSearchFilter"
        :required="true">
        <option
          v-for="searchFilter in searchFilters"
          :key="searchFilter.key"
          :value="searchFilter.key"
          :name="searchFilter.key"
          :selected="searchFilter.key === selectedSearchFilterId">
          {{ $t(searchFilter.value) }}
        </option>
      </select>
    </div>
    <input
      class="form-control"
      type="text"
      v-model="searchValue"
      @keyup="retrieveRecords"
      :placeholder="searchPlaceholder || 'Search...'"
    >
    <div v-if="showSearchActionButton">
      <button
        class="btn btn-primary first-button ml-2"
        type="button"
        @click="actionButtonClicked"
      >
        <i :class="searchActionButtonIcon || 'fa fa-plus'"></i> {{ searchActionButtonLabel }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchFilters',
  data() {
    return {
      searchValue: '',
      selectedSearchFilterId: this.searchFilters.length > 0 ? this.searchFilters[0].key : ''
    };
  },
  props: {
    searchFilters: {
      type: Array,
      required: true
    },
    searchPlaceholder: {
      type: String,
      default: 'Search...'
    },
    showSearchActionButton: {
      type: Boolean,
      default: false
    },
    searchActionButtonLabel: {
      type: String,
      default: 'Add'
    },
    searchActionButtonIcon: {
      type: String,
      default: 'fa fa-plus'
    }
  },
  methods: {
    changeSearchFilter() {
      this.$emit('search-filter-changed', {
        searchValue: this.searchValue,
        searchFilterId: this.selectedSearchFilterId
      });
    },
    retrieveRecords() {
      this.$emit('search-value-changed', {
        searchValue: this.searchValue,
        searchFilterId: this.selectedSearchFilterId
      });
    },
    actionButtonClicked() {
      this.$emit('search-action-button-clicked');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/SearchFilters.vue